export default __webpack_public_path__ + "static/logo-b9bea0d85e8536611cc9d10fb292751e.jpeg";